module.exports = __webpack_public_path__ + "img/register.ed06ccd2.svg";